import React, { useEffect, useState } from "react";
import socket from "../../socket";
import { getUser } from "../../auth"
import TopProductosTable from "../components/TopProductosTable";

const URL = process.env.REACT_APP_API_URL;

export default function TopProductos() {
  const [topProducts, setTopProducts] = useState([]);

  const fetchTopProductos = () => {
    const user = getUser();
    fetch(`${URL}/api/sales/summary/top-products/`, {
      headers: {
        "X-Empresa-Id": user?.empresa_id,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al obtener resumen");
        return res.json();
      })
      .then((data) => {
        const sorted = [...data].sort((a, b) => a.total - b.total);
        setTopProducts(sorted);
      })
      .catch(() => setTopProducts([]));
  }

  useEffect(() => {
    fetchTopProductos();
  }, []);

  useEffect(() => {
    socket.on("venta_creada", fetchTopProductos); // o fetchVentas
    socket.on("venta_borrada", fetchTopProductos);
    socket.on("venta_editada", fetchTopProductos);
  
    return () => {
      socket.off("venta_creada", fetchTopProductos);
      socket.off("venta_borrada", fetchTopProductos);
      socket.off("venta_editada", fetchTopProductos);
    };
  }, []);
  

  return (
    <TopProductosTable data={topProducts} />
  );
}
